import React from "react";
import { useLocation } from "react-router-dom";
import {Container} from "react-bootstrap";


const Breadcrumbs = ({ categories = [], products = [] }) => {
    const findCategoryPath = (categories, targetUrl, path = []) => {

        for (const category of categories) {
            const newPath = [...path, { label: category.name, path: `/catalog/${category.url}` }];
  
            if (category.url === targetUrl) {
                return newPath; // Нашли категорию, возвращаем путь
            }
    
            if (category.childCatalogs) {
                const subPath = findCategoryPath(category.childCatalogs, targetUrl, newPath);
                if (subPath) return subPath; // Нашли в подкатегориях
            }
        }
        return null; // Если не нашли, возвращаем null
    };
    
    // Генерация хлебных крошек
    const location = useLocation();
    const pathSegments = location.pathname
        .split("/")
        .filter(segment => segment && segment !== "catalog"); // Убираем пустые строки и "catalog"
    let breadcrumbs = [{ label: "Главная", path: "/" }, { label: "Каталог", path: "/catalog" }];
    
    if (pathSegments.length > 0) {
        const categoryPath = findCategoryPath(categories, pathSegments[0]); // Теперь путь корректный!
    
        if (categoryPath) {
            breadcrumbs = [...breadcrumbs, ...categoryPath];
        } 
    }
    
   // console.log("🍞 Итоговые хлебные крошки:", breadcrumbs);

    
    return (
        <Container>    
        <nav style={{padding: '6px', marginLeft: "5px" }}>
            {breadcrumbs.length > 0 ? (
                breadcrumbs.map((crumb, index) => (
                    <span key={index} style={{ marginRight: "5px" }}>
                        {index > 0 && " / "}
                        <a href={crumb.path} 
                            style={{
                                    paddingLeft: '0',
                                    paddingRight: '1rem',
                                    textDecoration: 'underline'
                                }}
                            >{crumb.label}</a>
                    </span>
                ))
            ) : (
                <span>Нет хлебных крошек</span>
            )}
        </nav>
        </Container>
    );
};

export default Breadcrumbs;

